import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import { withRouter } from "react-router-dom";
import { reduxForm, Field, initialize } from "redux-form";
import { connect } from "react-redux";
import {
  DetailContainer,
  FormContainer,
  Description,
} from "../decoration/PageDetailStyles";
import ProgressBar from "../../components/progressBar/ProgressBar";
import DecorationNavigation from "../../components/decorationNavigation/DecorationNavigation";
import SaveButton from "../../components/buttons/SaveButton";
import {
  findPageByTag,
  findPageByID,
} from "../../infra/services/utils/PageInfo";
import {
  findNextChapter,
  findPrevChapter,
} from "../../infra/services/utils/PageNavigation";
import GuestsRoomPlanForm from "./GuestsRoomPlanForm";
import { GetGuests, AddRoomPlan } from "../../infra/requests/GuestsRequests";
import { TransformToFormData } from "../../infra/services/formdata/TransformToFormData";
import { SpinLoading } from "../../styles/BasicStyles";
import { processClosed } from "../../infra/services/utils/BlockAnswers";
import LeavePageBlocker from "../../components/pageBlocker/LeavePageBlocker";

const sectionTag = "GUESTS";
const sectionId = "5e2adaa747f38787fd9e8424";
const returnURL = "/guests";

const FormValidations = (values) => {
  //console.log('FORM', values);
  return {};
};

class GuestsRoomPlan extends Component {
  state = {
    chapter: undefined,
    nextChapter: undefined,
    prevChapter: undefined,
    roomPlan: undefined,
    isProcessClosed: undefined,
    ready: false,
    loading: false,
  };

  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    document.body.style.overflowY = "auto";

    this.updateQuestion();
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps?.id) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      document.body.style.overflowY = "auto";

      this.updateQuestion();
    }
  }

  updateQuestion = async () => {
    const { weddingInfo, decorationInfo, dispatch } = this.props;

    const { chapters } = findPageByTag(decorationInfo, sectionTag);
    const chapter = findPageByID(chapters, sectionId);
    const nextChapter = findNextChapter(
      decorationInfo,
      chapter.section,
      chapters,
      chapter._id
    );
    const prevChapter = findPrevChapter(
      decorationInfo,
      chapter.section,
      chapters,
      chapter._id
    );
    // const isProcessClosed = processClosed(weddingInfo.date);
    const isProcessClosed = processClosed(weddingInfo.blockDate);

    dispatch(initialize("section_form", {}));

    const resultGuests = await GetGuests();
    let roomPlan = undefined;

    if (resultGuests.success) {
      dispatch(
        initialize("section_form", {
          room_plan: resultGuests.data.room_plan,
        })
      );

      roomPlan = resultGuests.data.room_plan;
    }

    this.setState({
      chapter,
      nextChapter,
      prevChapter,
      roomPlan,
      isProcessClosed,
      ready: true,
    });
  };

  onSubmit = async (values) => {
    try {
      this.setState({ loading: true });

      const { history } = this.props;
      const { nextChapter } = this.state;

      if (values.room_plan && values.room_plan.preview) {
        const payload = TransformToFormData({ file: values.room_plan });

        const { success } = await AddRoomPlan(payload);

        if (success) {
          history.push(`${returnURL}/${nextChapter?._id}`);
        }
      } else {
        history.push(`${returnURL}/${nextChapter?._id}`);
      }

      this.setState({ loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      roomPlans,
      weddingInfo,
      handleSubmit,
      translate,
      activeLanguage,
      history,
      dirty,
      submitting,
    } = this.props;
    const {
      chapter,
      nextChapter,
      prevChapter,
      roomPlan,
      isProcessClosed,
      ready,
      loading,
    } = this.state;

    if (!ready) return <SpinLoading />;

    let num_answers = 0;
    if (roomPlan) {
      num_answers++;
    }

    return (
      <React.Fragment>
        <LeavePageBlocker
          when={dirty && !submitting}
          message={translate("UNSAVED_OPTION_CHANGES")}
        />
        <ProgressBar
          type="section"
          num_questions={1}
          num_answers={num_answers}
        />
        <DecorationNavigation
          returnUrl={returnURL}
          mainCategory={chapter.name[activeLanguage?.code]}
          currentQuestion={chapter.name[activeLanguage?.code]}
          currentQuestionUrl={`${returnURL}/${sectionId}`}
          nextQuestion={nextChapter?.name[activeLanguage?.code]}
          nextQuestionUrl={`${returnURL}/${nextChapter?._id}`}
          prevQuestion={prevChapter?.name[activeLanguage?.code]}
          prevQuestionUrl={`${returnURL}/${prevChapter?._id}`}
        />
        <DetailContainer>
          {chapter.description && (
            <Description
              dangerouslySetInnerHTML={{
                __html:
                  chapter.description &&
                  chapter.description[activeLanguage?.code],
              }}
            />
          )}
          <FormContainer onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              name="response"
              component={GuestsRoomPlanForm}
              questions={chapter.questions}
              roomPlans={roomPlans}
              weddingInfo={weddingInfo}
              isProcessClosed={isProcessClosed}
            />
            {!isProcessClosed && (
              <SaveButton
                htmlType="submit"
                text={translate("SAVE_CONTINUE")}
                textMobile={translate("SAVE")}
                withBackground={true}
                loading={loading}
              />
            )}
          </FormContainer>
          {isProcessClosed && (
            <SaveButton
              htmlType="button"
              text={translate("CONTINUE")}
              textMobile={translate("CONTINUE")}
              withBackground={true}
              onClick={() => history.push(`${returnURL}/${nextChapter?._id}`)}
            />
          )}
        </DetailContainer>
      </React.Fragment>
    );
  }
}

GuestsRoomPlan = reduxForm({
  form: "section_form",
  validate: FormValidations,
})(GuestsRoomPlan);

const mapStateToProps = (state) => ({
  decorationInfo: state.wedding.structure,
  roomPlans: state.info.room_plans,
  weddingInfo: state.wedding.wedding,
});

export default connect(mapStateToProps)(
  withLocalize(withRouter(GuestsRoomPlan))
);
